import React from "react";
import { findIcon } from "../../../../dashboard/icons";
import { getRelativeDateFromNow } from "../../../../../common/utils/utils";
import { fallbackImages } from "../../../../../common/constants/fallback-images";

const CommentCard = ({ item }) => {
  return (
    <div className="d-flex border-bottom border-2 align-items-center justify-content-between m-3 p-2 gap-3">
      <div className="d-flex align-items-center gap-3 col-md-6">
        <div className="opacity-50">{findIcon("Quote", "dual-tone", 36)}</div>

        <div className="col-md-6">
          <p className="mb-1 poppins-light" style={{ color: "#161616" }}>
            {item?.comment}
          </p>
          <p className="poppins-medium" style={{ color: "#161616" }}>
            @{item?.commented_by}
            <span className="opacity-50">{` . ${getRelativeDateFromNow(
              item?.commented_on
            )}`}</span>
          </p>
        </div>
      </div>

      <div className="d-flex gap-3 col-md-6 align-items-center">
        <div>
          <img
            src={item?.thumbnail}
            alt={"content-image"}
            onError={(e) => (e.target.src = fallbackImages.noImage)}
            width={"116px"}
            height={"64px"}
            className="rounded-2"
          />
        </div>
        <div>
          <p className="fw-semibold text-black">{item.title}</p>
        </div>
      </div>
    </div>
  );
};

export default CommentCard;
